import {StartTimesTablesRequestModel} from "@/api/api.clients";

export class StartTimesTablesRequest implements StartTimesTablesRequestModel {
    constructor(public  tables: number[], public traineeId: string) {
    }
}
